module.exports = __webpack_public_path__ + "img/btn2.375b9dfe.png";